export default {
  SET_CSV_DATA(state, cvsData) {
    state.records = cvsData;
  },
  SET_CSV_RECORDS(state, totalRecords) {
    state.totalRecords = totalRecords;
  },
};
